export default __webpack_public_path__ + "img/work.adce390a.png";